import { APICfg } from 'services/api/api'
import { uploadOrKeepImg } from '../../common'
import { productCommonParse } from '../productCommon'
import { parseImage } from '../utils'
import { LogisticToApi } from './types/api/request-models'
import { APILogistic } from './types/api/response-models'
import { Logistic } from './types/internal/logistic-models'

// ============
// PARSE
// ============

export const parseLogistic = (log: APILogistic): Logistic => {
  const { images, ...rest } = log
  return {
    ...rest,
    ...productCommonParse(log),
    image: parseImage(images[0]),
  }
}

// ============
// WRITE
// ============

const logisticWrite = async (req: Logistic): Promise<LogisticToApi> => {
  const imgId = await uploadOrKeepImg(req.image)

  return {
    ...req,
    images: imgId ? [imgId] : [],
  }
}

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'logistic',
  parse: parseLogistic,
  write: logisticWrite,
}

export default apiCfg
